export var IntegrationProvider;
(function (IntegrationProvider) {
    IntegrationProvider["JIRA"] = "jira";
    IntegrationProvider["MONDAY"] = "monday";
    IntegrationProvider["SHAREPOINT"] = "sharepoint";
    IntegrationProvider["DYNAMICS_CRM"] = "dynamics-crm";
    IntegrationProvider["CONFLUENCE"] = "confluence";
})(IntegrationProvider || (IntegrationProvider = {}));
